export default __webpack_public_path__ + "static/media/480_business05-en-web.7562844b.png";